import { Avatar, Button, Modal, Paper, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { BlueFilters } from 'Images';
import { AllFiltersForm } from './Form';
import { ActiveFiltersBubble } from 'Components/ControlledDropdown/ActiveFiltersBubble';
import { useContext } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';
import { checkedFilterCounter } from 'Utils/supplierFilterManager';

interface IAllFilters {
  openModal: boolean;
  setOpenModal: Function;
}
export const AllFilters = ({ openModal, setOpenModal }: IAllFilters) => {
  const { filters } = useContext(SuppliersContext);

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  const selectedHiddenFilters: number = checkedFilterCounter(
    filters,
    isDesktop
      ? [
          'specialty',
          'subSpecial',
          'city',
          'treatMethod',
          'orderByAscendingAlphabet',
          'orderByDescendingAlphabet',
          'location',
        ]
      : ['specialty', 'subSpecial', 'city']
  );

  return (
    <>
      <Button
        sx={{
          p: isDesktop ? '10px 16px 10px 16px' : '8px 16px',
          bgcolor: '#FFF !important',
          border: '1px solid',
          borderColor: '#1552E8',
          borderRadius: '32px',
          gap: '4px',
          height: '46px',
        }}
        onClick={() => setOpenModal(true)}
      >
        {selectedHiddenFilters > 0 && (
          <ActiveFiltersBubble activeFiltersAmount={selectedHiddenFilters} />
        )}
        <Avatar
          alt=''
          src={BlueFilters}
          sx={{
            width: '18px',
            height: '18px',
          }}
        />
        <Typography variant='body1'>
          {isDesktop ? dictionary.allFilters : dictionary.sortAndFilter}
        </Typography>
      </Button>
      <Modal
        open={openModal}
        aria-modal={true}
        aria-labelledby={dictionary.allFilters}
        aria-describedby={dictionary.ariaDescribeAllFilters}
      >
        <Paper
          sx={{
            position: 'absolute',
            top: '110px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            maxWidth: '1000px',
            maxHeight: '85vh',
            overflow: 'auto',
            bgcolor: '#FFF',
            p: isDesktop ? '0 32px 48px 32px' : '0 32px 96px 32px',
            borderRadius: '16px',
            border: '1px solid #E7EDFF',
            boxShadow: '-2px -2px 10px 0px #081E540A',
          }}
        >
          <AllFiltersForm setOpenModal={setOpenModal} />
        </Paper>
      </Modal>
    </>
  );
};
